import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm, useFieldArray } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import removeImg from "assets/svgs/close.svg";

import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection, addSection } from "store/actions";
import Loader from "components/shared/Loader";
import { useState } from "react";

import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import ImageUpload from "components/shared/ImageUpload";
import { isObjectNotEmpty } from "helpers/functions";

const OtherProjects = () => {
  const { formatMessage, locale } = useIntl();
  const [selectedImages, setSelectedImages] = useState([]);
  const { loading, error, section } = useSelector((state) => state.section);
  const dispatch = useDispatch();

  const {
    control,
    register,
    reset,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      items: section?.items,
    },
  });

  const { fields, append, remove } = useFieldArray({
    control: control,
    name: "items",
  });

  const addItems = () => {
    append({
      image: "",
      title: { ar: "", en: "" },
      description: { ar: "", en: "" },
    });
  };

  useEffect(() => {
    if (fields?.length === 0 && !isObjectNotEmpty(section)) {
      addItems();
    }
  }, [fields]);

  useEffect(() => {
    dispatch(
      getSection({
        page: "home",
        slug: "other-projects",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    reset(section);
  }, [reset, section]);

  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    console.log("data >>>>", data);
    // loop on items in data and check if image is not empty
    const itemsWithoutImage = data.items.filter(
      (item, index) => item.image === ""
    );
    if (itemsWithoutImage?.length > 0) {
      toastErrorMessage(formatMessage({ id: "imageErrorMessage" }), locale);
      return;
    }

    dispatch(
      editSection({
        slug: "other-projects",
        page: "home",
        data: { section: data },
      })
    );
    // if (section?.items?.length > 0) {
    // }
    //  else {
    //   const newData = { section: { title: "teamWork", ...data } };
    //   dispatch(
    //     addSection({
    //       page: "about",
    //       data: newData,
    //       slug: "teamWork",
    //     })
    //   );
    // }
  };

  useEffect(() => {
    setValue(`sectionTitle.ar`, section?.sectionTitle?.ar || "");
    setValue(`sectionTitle.en`, section?.sectionTitle?.en || "");

    section?.items?.forEach((item, index) => {
      setValue(`items[${index}].image`, item?.image || "");

      setValue(`items[${index}].title.ar`, item?.title?.ar || "");
      setValue(`items[${index}].title.en`, item?.title?.en || "");
      setValue(`items[${index}].description.ar`, item?.description?.ar || "");
      setValue(`items[${index}].description.en`, item?.description?.en || "");
    });
  }, [section, setValue]);

  if (loading) return <Loader />;

  return (
    <div className="acc-form">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="card">
          <h5 className="card-title my-4">
            <FormattedMessage id={"sectionDetails"} />
          </h5>

          <div className="card-body">
            <Col xl={12}>
              <div className="add-multi-component">
                <Row>
                  {/* Arabic title Input */}

                  <Col xxl={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"title"} />
                        <>
                          (<FormattedMessage id={"arabic-language"} />){" "}
                        </>
                      </h5>
                      <input
                        name={`sectionTitle.ar`}
                        type="text"
                        className="form-control form-outline"
                        {...register(`sectionTitle.ar`, {
                          required: formatMessage({ id: "requiredField" }),
                          minLength: {
                            value: 3,
                            message: formatMessage({ id: "minLength" }),
                          },
                          maxLength: {
                            value: 30,
                            message: formatMessage({ id: "maxLength" }),
                          },
                        })}
                      />

                      {errors?.sectionTitle?.ar?.message && (
                        <p className="error-hint">
                          {errors?.sectionTitle?.ar?.message}
                        </p>
                      )}
                    </div>
                  </Col>

                  {/* English subtitle Input */}

                  <Col xxl={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"title"} />

                        <>
                          {" "}
                          (<FormattedMessage id={"english-language"} />){" "}
                        </>
                      </h5>
                      <input
                        name={`sectionTitle.en`}
                        type="text"
                        className="form-control form-outline"
                        {...register(`sectionTitle.en`, {
                          required: formatMessage({ id: "requiredField" }),
                          minLength: {
                            value: 3,
                            message: formatMessage({ id: "minLength" }),
                          },
                          maxLength: {
                            value: 30,
                            message: formatMessage({ id: "maxLength" }),
                          },
                        })}
                      />

                      {errors?.sectionTitle?.en?.message && (
                        <p className="error-hint">
                          {errors?.sectionTitle?.en?.message}
                        </p>
                      )}
                    </div>
                  </Col>

                  {/* =========================================================================================== */}
                </Row>
              </div>
            </Col>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <Row>
              <div className="card-head my-5">
                <h4>
                  <FormattedMessage id={"otherProjects"} />
                </h4>
              </div>
              {fields?.length > 0 &&
                fields?.map((item, index) => {
                  return (
                    <Col sx={12} md={6} key={item.id}>
                      <div className="add-multi-component mt-4">
                        <Row>
                          <div className="form-group required">
                            <h5>
                              <FormattedMessage id={"image"} />
                            </h5>
                            <ImageUpload
                              selectedImage={{
                                path: selectedImages[index]?.path || item.image,
                              }}
                              setSelectedImage={(image) => {
                                setSelectedImages((prevImages) => {
                                  const updatedImages = [...prevImages];
                                  updatedImages[index] = image;
                                  return updatedImages;
                                });
                                setValue(`items[${index}].image`, image.path);
                              }}
                            />
                          </div>
                          {/* Arabic Title Input */}
                          <Col xs={12} xl={6}>
                            <div className="form-group">
                              <h5>
                                <FormattedMessage id={"projectName"} />

                                <>
                                  {" "}
                                  (<FormattedMessage
                                    id={"arabic-language"}
                                  />){" "}
                                </>
                              </h5>
                              <input
                                name={`items[${index}].title.ar`}
                                type="text"
                                className="form-control form-outline"
                                {...register(`items[${index}].title.ar`, {
                                  required: formatMessage({
                                    id: "requiredField",
                                  }),
                                  minLength: {
                                    value: 3,
                                    message: formatMessage({ id: "minLength" }),
                                  },
                                  maxLength: {
                                    value: 40,
                                    message: formatMessage({ id: "maxLength" }),
                                  },
                                })}
                              />

                              {errors?.items?.[index]?.title?.ar?.message && (
                                <p className="error-hint">
                                  {errors?.items?.[index]?.title?.ar?.message}
                                </p>
                              )}
                            </div>
                          </Col>
                          {/* =========================================================================================== */}

                          {/* English Title Input */}

                          <Col xs={12} xl={6}>
                            <div className="form-group">
                              <h5>
                                <FormattedMessage id={"projectName"} />

                                <>
                                  {" "}
                                  (<FormattedMessage
                                    id={"english-language"}
                                  />){" "}
                                </>
                              </h5>
                              <input
                                name={`items[${index}].title.en`}
                                type="text"
                                className="form-control form-outline"
                                {...register(`items[${index}].title.en`, {
                                  required: formatMessage({
                                    id: "requiredField",
                                  }),
                                  minLength: {
                                    value: 3,
                                    message: formatMessage({ id: "minLength" }),
                                  },
                                  maxLength: {
                                    value: 40,
                                    message: formatMessage({ id: "maxLength" }),
                                  },
                                })}
                              />

                              {errors?.items?.[index]?.title?.en?.message && (
                                <p className="error-hint">
                                  {errors?.items[index]?.title?.en?.message}
                                </p>
                              )}
                            </div>
                          </Col>
                          {/* =========================================================================================== */}

                          <Col xs={12} xl={6}>
                            <div className="form-group">
                              <h5>
                                <FormattedMessage id={"description"} />

                                <>
                                  {" "}
                                  (<FormattedMessage
                                    id={"arabic-language"}
                                  />){" "}
                                </>
                              </h5>
                              <textarea
                                name={`items[${index}].description.ar`}
                                type="text"
                                className="form-control form-outline"
                                {...register(`items[${index}].description.ar`, {
                                  required: formatMessage({
                                    id: "requiredField",
                                  }),
                                  minLength: {
                                    value: 3,
                                    message: formatMessage({ id: "minLength" }),
                                  },
                                  maxLength: {
                                    value: 200,
                                    message: formatMessage({ id: "maxLength" }),
                                  },
                                })}
                              />

                              {errors?.items?.[index]?.description?.ar
                                ?.message && (
                                <p className="error-hint">
                                  {
                                    errors?.items[index]?.description?.ar
                                      ?.message
                                  }
                                </p>
                              )}
                            </div>
                          </Col>

                          {/* =========================================================================================== */}

                          <Col xs={12} xl={6}>
                            <div className="form-group">
                              <h5>
                                <FormattedMessage id={"description"} />

                                <>
                                  {" "}
                                  (<FormattedMessage
                                    id={"english-language"}
                                  />){" "}
                                </>
                              </h5>
                              <textarea
                                name={`items[${index}].description.en`}
                                type="text"
                                className="form-control form-outline"
                                {...register(`items[${index}].description.en`, {
                                  required: formatMessage({
                                    id: "requiredField",
                                  }),
                                  minLength: {
                                    value: 3,
                                    message: formatMessage({ id: "minLength" }),
                                  },
                                  maxLength: {
                                    value: 200,
                                    message: formatMessage({ id: "maxLength" }),
                                  },
                                })}
                              />

                              {errors?.items?.[index]?.description?.en
                                ?.message && (
                                <p className="error-hint">
                                  {
                                    errors?.items[index]?.description?.en
                                      ?.message
                                  }
                                </p>
                              )}
                            </div>
                          </Col>

                          {/* Remove Button */}
                          {fields.length > 1 && (
                            <button
                              type="button"
                              onClick={() => remove(index)}
                              className="removeImg"
                            >
                              <img src={removeImg} alt="Remove" />
                            </button>
                          )}
                        </Row>
                      </div>
                    </Col>
                  );
                })}
            </Row>
          </div>
        </div>
        <Row>
          <Col lg={4} xs={12} className="text-left mb-3">
            <button
              type="button"
              className="btn btn-green add_new_section__ w-100"
              onClick={addItems}
            >
              <FormattedMessage id={"addCollection"} />
            </button>
          </Col>
        </Row>
        <SaveChangesButton />
      </form>
    </div>
  );
};

export default OtherProjects;
